import { Dispatch } from 'redux';
import { ApiWebhook, webhookApi } from '../apis';
import { WebhookModalValues } from './WebhookModal';
import { showFeedback } from '../feedback/feedbackReducer';

export const addWebhook =
  (values: WebhookModalValues) =>
  async (dispatch: Dispatch): Promise<ApiWebhook> => {
    const apiCreateWebhook = {
      trigger: values.trigger,
      url: values.url,
      token: values.token,
    };
    const webhook = await webhookApi.addWebhook({ apiCreateWebhook });
    dispatch(
      showFeedback({
        message: `Webhook #${webhook.id} added!`,
        success: true,
      })
    );
    return webhook;
  };

export const updateWebhook =
  (webhookId: number, values: WebhookModalValues) =>
  async (dispatch: Dispatch): Promise<ApiWebhook> => {
    const apiWebhook = {
      trigger: values.trigger,
      url: values.url,
      token: values.token,
    };
    const webhook = await webhookApi.updateWebhook({
      webhookId: webhookId,
      apiCreateWebhook: apiWebhook,
    });
    dispatch(
      showFeedback({
        message: `Webhook #${webhook.id} updated!`,
        success: true,
      })
    );
    return webhook;
  };

export const deleteWebhook = (webhook: ApiWebhook) => async (dispatch: Dispatch) => {
  await webhookApi.deleteWebhook({ webhookId: webhook.id });
  dispatch(
    showFeedback({
      message: `Webhook #${webhook.id} deleted!`,
      success: true,
    })
  );
};
